<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <data-tables
          :headers="headers"
          :table-data="tableData"
          @downloadTessera="downloadTessera"
          @downloadDiploma="downloadDiploma"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DataTables from "@/components/base/DataTables.vue";
import Swal from "sweetalert2";
const _ = this;
export default {
  name: "list-tessere-table",
  components: {
    DataTables,
  },
  props: {
    masterId: null,
  },
  watch: {
    masterId: function (newVal, oldVal) {
      // watch it
      if (newVal) this.loadTable();
    },
  },
  data() {
    return {
      isFetching: true,

      headers: [
        { value: "dateTes", text: this.$t("date_affiliation"), type: "date" },
        { value: "tesAnno", text: this.$t("season"), type: "numeric" },
        {
          value: "asdRagSocWithImage",
          height: 20,
          text: this.$t("ente_association"),
          type: "imageText",
        },
        {
          value: "nome",
          text: this.$t("type_affiliation_card"),
          type: "string",
        },
        {
          value: "tesseraEnte",
          text: this.$t("number_affiliation_card"),
          type: "string",
        },
        { text: this.$t("options"), value: "options", type: "buttons" },
      ],
      tableData: [],
    };
  },
  methods: {
    downloadTessera(item) {
      this.$documentViewer.documentViewerRsp.docUrl = item.tesseraUrl;
    },
    downloadDiploma(item) {
      this.$documentViewer.documentViewerRsp.docUrl = item.diplomaUrl;
    },
    loadTable() {
      let url = "/auth/tesseramenti/listUserTessere/";
      const _ = this;
      if (_._props.masterId) url += "/" + _._props.masterId;

      this.chiamataAxios("GET", url).then((response) => {
        _.tableData = response.data.map((tessera) => {
          tessera.options = [];
          tessera.asdRagSocWithImage = {
            image: tessera.badge,
            text: tessera.asdRagSoc,
          };

          if (tessera.havePdf)
            tessera.options.push({
              icon: "mdi-card-account-details-outline",
              color: "green",
              text: _.$t("card"),
              function: "downloadTessera",
            });
          if (tessera.haveDiplomaPdf)
            tessera.options.push({
              icon: "mdi-certificate-outline",
              color: "green",
              text: _.$t("diploma"),
              function: "downloadDiploma",
            });
          return tessera;
        });
        _.isFetching = false;
      });
    },
  },
  mounted() {
    this.loadTable();
  },
};
</script>
